const SERVER_URL = 'https://santeskills.com/Controller';
const LOCAL_URL = 'http://localhost/sante/Controller';

const BASE_URL = SERVER_URL;

const QR_CODE_BASE_URL = 'https://santeskills.com'; // Rota gerado no QR Code

const IMG_BASE_URL = BASE_URL.replace(/\/Controller\/?$/, '/'); // Rota para arquivos

export const URLS = {
    // Rota QR Code
    QR_CODE_PATH: `${QR_CODE_BASE_URL}/`,

    // Rota para mostrar imagens
    IMG_PATH: `${IMG_BASE_URL}assets/`,

    // Rota para login
    LOGIN_ADMIN: `${BASE_URL}/usuario/loginAdmin.php`,
    LOGIN_PARTICIPANTE: `${BASE_URL}/participante/loginParticipante.php`,

    // Renovar JWT
    RENEW_JWT: `${BASE_URL}/participante/renew-token.php`,

    // Rotas para produtos
    CREATE_PRODUTO: `${BASE_URL}/produto/produtoCreate.php`,
    UPDATE_PRODUTO: `${BASE_URL}/produto/produtoUpdate.php`,
    DELETE_PRODUTO: `${BASE_URL}/produto/produtoDelete.php`,
    READ_PRODUTO: `${BASE_URL}/produto/produtoRead.php`,
    READ_ALL_PRODUTO: `${BASE_URL}/produto/produtoReadAllWeb.php`,

    // Rotas para testes
    CREATE_TESTE: `${BASE_URL}/teste/testeCreate.php`,
    CREATE_PRODUTO_TESTE: `${BASE_URL}/teste/produtoTesteCreate.php`,
    UPDATE_TESTE: `${BASE_URL}/teste/testeUpdate.php`,
    DELETE_PRODUTO_TESTE: `${BASE_URL}/teste/produtoTesteDelete.php`,
    DELETE_TESTE: `${BASE_URL}/teste/testeDelete.php`,
    READ_BY_TESTE_ID: `${BASE_URL}/teste/testeReadById.php`,
    READ_ALL_TESTE: `${BASE_URL}/teste/testeReadAll.php`,
    READ_PRODUTO_TESTE_BY_TEST_ID: `${BASE_URL}/teste/produtoTesteReadByTestId.php`,

    // Rotas para vídeos
    CREATE_VIDEO: `${BASE_URL}/video/videoCreate.php`,
    CREATE_PRODUTO_VIDEO: `${BASE_URL}/video/produtoVideoCreate.php`,
    READ_ALL_VIDEO: `${BASE_URL}/video/videoReadAll.php`,
    READ_VIDEO_BY_ID: `${BASE_URL}/video/videoReadById.php`,
    UPDATE_VIDEO: `${BASE_URL}/video/videoUpdate.php`,
    DELETE_VIDEO: `${BASE_URL}/video/videoDelete.php`,
    DELETE_PRODUTO_VIDEO: `${BASE_URL}/video/produtoVideoDelete.php`,
    READ_PRODUTO_VIDEO_BY_VIDEO_ID: `${BASE_URL}/video/produtoVideoReadByVideoId.php`,

    // Rotas para usuários
    CREATE_USUARIO: `${BASE_URL}/usuario/webEndpoints/usuarioCreateWeb.php`,
    UPDATE_USUARIO: `${BASE_URL}/usuario/webEndpoints/usuarioUpdateWeb.php`,
    DELETE_USUARIO: `${BASE_URL}/usuario/webEndpoints/usuarioDeleteWeb.php`,
    READ_ALL_USUARIO: `${BASE_URL}/usuario/webEndpoints/usuarioReadAllWeb.php`,
    READ_BY_ID_USUARIO: `${BASE_URL}/usuario/webEndpoints/usuarioReadByIdWeb.php`,
    READ_BY_NAME_USUARIO: `${BASE_URL}/usuario/webEndpoints/usuarioReadByNomeWeb.php`,

    GEN_COD_RECUPERACAO_USUARIO: `${BASE_URL}/usuario/webEndpoints/genCodRecuperacaoUsuario.php`,
    VER_COD_RECUPERACAO_USUARIO: `${BASE_URL}/usuario/webEndpoints/verCodRecuperacaoUsuario.php`,

    READ_BY_USER_ID_PRODUTO_USUARIO: `${BASE_URL}/produto/produtoUsuarioReadByUserIdWeb.php`,
    ASSINA_PRODUTO: `${BASE_URL}/produto/assinaProdutoWeb.php`,
    ASSINA_PRODUTO_DELETE: `${BASE_URL}/produto/assinaProdutoDeleteWeb.php`,

    // Rotas para institucional
    UPDATE_INSTITUCIONAL: `${BASE_URL}/institucional/institucionalUpdate.php`,
    READ_ALL_INSTITUCIONAL: `${BASE_URL}/institucional/institucionalReadAll.php`,

    // Rotas para empresas
    CREATE_EMPRESA: `${BASE_URL}/empresa/empresaCreate.php`,
    UPDATE_EMPRESA: `${BASE_URL}/empresa/empresaUpdate.php`,
    DELETE_EMPRESA: `${BASE_URL}/empresa/empresaDelete.php`,
    READ_EMPRESA: `${BASE_URL}/empresa/empresaRead.php`,
    READ_ALL_EMPRESA: `${BASE_URL}/empresa/empresaReadAll.php`,

    // Rotas para turma
    CREATE_TURMA: `${BASE_URL}/turma/turmaCreate.php`,
    UPDATE_TURMA: `${BASE_URL}/turma/turmaUpdate.php`,
    DELETE_TURMA: `${BASE_URL}/turma/turmaDelete.php`,
    READ_TURMA: `${BASE_URL}/turma/turmaRead.php`,
    READ_ALL_TURMA: `${BASE_URL}/turma/turmaReadAll.php`,
    READ_TURMA_BY_EMPRESA: `${BASE_URL}/turma/turmaReadByEmpresaId.php`,
    TOGGLE_STATUS_TURMA: `${BASE_URL}/turma/turmaStatusToggle.php`,

    CREATE_PARTICIPANTE_TURMA: `${BASE_URL}/participanteTurma/participanteTurmaCreate.php`,

    // Rotas lembretes turmas
    CREATE_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataCreate.php`,
    DELETE_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataDelete.php`,
    DELETE_BY_TURMA_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataDeleteByTurma.php`,
    READ_ALL_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataRead.php`,
    READ_BY_ID_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataReadById.php`,
    READ_BY_TURMA_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataReadByTurma.php`,
    UPDATE_LEMBRETE_TURMA: `${BASE_URL}/turmaLembreteData/turmaLembreteDataUpdate.php`,

    // Rotas para participantes
    CREATE_PARTICIPANTE: `${BASE_URL}/participante/participanteCreate.php`,
    READ_BY_CELULAR_PARTICIPANTE: `${BASE_URL}/participante/participanteReadByCelular.php`,
    READ_PARTICIPANTE: `${BASE_URL}/participante/participanteRead.php`,
    READ_ALL_PARTICIPANTE: `${BASE_URL}/participante/participanteReadAll.php`,
    UPDATE_PARTICIPANTE: `${BASE_URL}/participante/participanteUpdate.php`,
    DELETE_PARTICIPANTE: `${BASE_URL}/participante/participanteDelete.php`,

    GEN_COD_RECUPERACAO: `${BASE_URL}/participante/genCodRecuperacao.php`,
    VER_COD_RECUPERACAO: `${BASE_URL}/participante/verCodRecuperacao.php`,

    READ_ALL_PARTICIPANTE_BY_TURMA: `${BASE_URL}/participanteTurma/participanteTurmaReadByTurma.php`,

    // Rotas para resultados dos testes
    READ_RESULT: `${BASE_URL}/resultadoTeste/calcResulAlg.php`,
    GERAR_PDF_DEVOLUTIVA: `${BASE_URL}/resultadoTeste/composeResultPdf.php`,
    GET_LAST_RESULT: `${BASE_URL}/resultadoTeste/getLastResult.php`,

    CREATE_RESULTADO_TESTE: `${BASE_URL}/resultadoTeste/resultadoTesteCreate.php`,
    UPDATE_RESULTADO_TESTE_ALG: `${BASE_URL}/resultadoTeste/updateCalcAlg.php`,
    READ_RESULTADO_TESTE: `${BASE_URL}/resultadoTeste/resultadoTesteRead.php`,
    READ_ALL_RESULTADO_TESTE: `${BASE_URL}/resultadoTeste/resultadoTesteReadAll.php`,
    READ_BY_PARTICIPANTE_RESULTADO_TESTE: `${BASE_URL}/resultadoTeste/resultadoTesteReadByParticipante.php`,
    DELETE_RESULTADO_TESTE: `${BASE_URL}/resultadoTeste/resultadoTesteDelete.php`,
    EXISTS_RESULTADO_TESTE: `${BASE_URL}/resultadoTeste/resultadoTesteExists.php`,
    GET_RESULTADO_QUATRO_ELEMENTOS: `${BASE_URL}/resultadoTeste/quatroElementosResult.php`,
    GET_RESULTADO_MAPA_CEREBRAL: `${BASE_URL}/resultadoTeste/mapaCerebralResult.php`,

    // Rotas para algoritmos
    TESTE_ALGORITMO_CREATE: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoCreate.php`,
    TESTE_ALGORITMO_GET: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoGet.php`,
    TESTE_ALGORITMO_LIST: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoList.php`,
    TESTE_ALGORITMO_LIST_BY_TESTE: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoListByTeste.php`,
    TESTE_ALGORITMO_GET_LATEST_PUBLISHED: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoGetLatestPublished.php`,
    TESTE_ALGORITMO_GET_LATEST_DRAFT: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoGetLatestDraft.php`,
    TESTE_ALGORITMO_GET_CURRENT: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoGetCurrent.php`,
    TESTE_ALGORITMO_UPDATE: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoUpdate.php`,
    TESTE_ALGORITMO_DELETE: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoDelete.php`,
    TESTE_ALGORITMO_PUBLISH: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoPublish.php`,
    TESTE_ALGORITMO_ARCHIVE: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoArchive.php`,
    TESTE_ALGORITMO_SET_CURRENT: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoSetCurrent.php`,
    TESTE_ALGORITMO_CLONE: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoClone.php`,
    TESTE_ALGORITMO_PUBLISH_AND_SET_CURRENT: `${BASE_URL}/testeAlgoritmo/testeAlgoritmoPublishAndSetCurrent.php`,

    // Rotas para report assets (devolutivas PDF)
    CREATE_REPORT_ASSET: `${BASE_URL}/reportAsset/reportAssetCreate.php`,
    UPDATE_REPORT_ASSET: `${BASE_URL}/reportAsset/reportAssetUpdate.php`,
    DELETE_REPORT_ASSET: `${BASE_URL}/reportAsset/reportAssetDelete.php`,
    READ_REPORT_ASSET: `${BASE_URL}/reportAsset/reportAssetGet.php`,
    LIST_COMMONS_BY_ALG: `${BASE_URL}/reportAsset/reportAssetListCommons.php`,
    LIST_BY_PROFILE: `${BASE_URL}/reportAsset/reportAssetListByProfile.php`,
    LIST_ALL_FOR_ALG: `${BASE_URL}/reportAsset/reportAssetListAllForAlg.php`,
    UPDATE_FILE_META: `${BASE_URL}/reportAsset/reportAssetUpdateFileMeta.php`,
    SET_ACTIVE_REPORT_ASSET: `${BASE_URL}/reportAsset/reportAssetSetActive.php`,
    REORDER_REPORT_ASSET_GROUP: `${BASE_URL}/reportAsset/reportAssetReorderGroup.php`,
    COMPOSE_SOURCES_LIST: `${BASE_URL}/reportAsset/reportAssetComposeList.php`,
    SEARCH_REPORT_ASSETS: `${BASE_URL}/reportAsset/reportAssetSearch.php`,

    // Rotas para envio de mensagens
    SEND_CHART: `${BASE_URL}/teste/enviarImagemResultado.php`,
    SEND_PDF: `${BASE_URL}/teste/enviarPdfResultado.php`,

    // Rotas para trilha
    CREATE_TRILHA: `${BASE_URL}/trilha/trilhaCreate.php`,
    UPDATE_TRILHA: `${BASE_URL}/trilha/trilhaUpdate.php`,
    DELETE_TRILHA: `${BASE_URL}/trilha/trilhaDelete.php`,
    GET_TRILHAS: `${BASE_URL}/trilha/trilhaRead.php`,
    GET_TRILHA_BY_ID: `${BASE_URL}/trilha/trilhaReadById.php`,
    GET_TRILHAS_COM_CERTIFICADO: `${BASE_URL}/trilha/trilhaReadComCertificado.php`,

    // Rotas para módulos
    CREATE_MODULO: `${BASE_URL}/modulo/moduloCreate.php`,
    UPDATE_MODULO: `${BASE_URL}/modulo/moduloUpdate.php`,
    DELETE_MODULO: `${BASE_URL}/modulo/moduloDelete.php`,
    READ_MODULO: `${BASE_URL}/modulo/moduloRead.php`,
    READ_MODULO_BY_ID: `${BASE_URL}/modulo/moduloReadById.php`,
    READ_MODULO_BY_TRILHA: `${BASE_URL}/modulo/moduloReadByTrilha.php`,
    READ_MODULO_PUBLICADOS_BY_TRILHA: `${BASE_URL}/modulo/moduloReadPublicadosByTrilha.php`,
    IS_MODULO_ABERTO: `${BASE_URL}/modulo/moduloIsAberto.php`,
    SET_STATUS_MODULO: `${BASE_URL}/modulo/moduloSetStatus.php`,
    PUBLICAR_MODULO: `${BASE_URL}/modulo/moduloPublicar.php`,
    RASCUNHO_MODULO: `${BASE_URL}/modulo/moduloRascunho.php`,
    INATIVAR_MODULO: `${BASE_URL}/modulo/moduloInativar.php`,

    CREATE_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoCreate.php`,
    UPDATE_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoUpdate.php`,
    DELETE_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoDelete.php`,
    READ_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoRead.php`,
    READ_MODULO_SECAO_BY_ID: `${BASE_URL}/moduloSecao/moduloSecaoReadById.php`,
    READ_MODULO_SECAO_BY_MODULO: `${BASE_URL}/moduloSecao/moduloSecaoReadByModulo.php`,
    SET_STATUS_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoSetStatus.php`,
    PUBLICAR_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoPublicar.php`,
    RASCUNHO_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoRascunho.php`,
    INATIVAR_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoInativar.php`,
    SET_OBRIGATORIA_MODULO_SECAO: `${BASE_URL}/moduloSecao/moduloSecaoSetObrigatoria.php`,

    CREATE_MODULO_CONTEUDO: `${BASE_URL}/moduloConteudo/moduloConteudoCreate.php`,
    UPDATE_MODULO_CONTEUDO: `${BASE_URL}/moduloConteudo/moduloConteudoUpdate.php`,
    DELETE_MODULO_CONTEUDO: `${BASE_URL}/moduloConteudo/moduloConteudoDelete.php`,
    READ_MODULO_CONTEUDO: `${BASE_URL}/moduloConteudo/moduloConteudoRead.php`,
    READ_MODULO_CONTEUDO_BY_ID: `${BASE_URL}/moduloConteudo/moduloConteudoReadById.php`,
    READ_MODULO_CONTEUDO_BY_SECAO: `${BASE_URL}/moduloConteudo/moduloConteudoReadBySecao.php`,

    // Rotas para Participante Seção Conclusão

    CREATE_PARTICIPANTE_SECAO_CONCLUSAO: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoUpsert.php`,
    MARK_PARTICIPANTE_SECAO_CONCLUIDA: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoMarkConcluida.php`,
    MARK_PARTICIPANTE_SECAO_NAO_CONCLUIDA: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoMarkNaoConcluida.php`,
    READ_PARTICIPANTE_SECAO_CONCLUSAO_BY_ID: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoReadById.php`,
    READ_PARTICIPANTE_SECAO_CONCLUSAO_BY_PARTICIPANTE_TURMA: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoReadByParticipanteTurma.php`,
    READ_PARTICIPANTE_SECAO_CONCLUSAO_BY_PARTICIPANTE_TURMA_AND_SECAO: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoReadByParticipanteTurmaAndSecao.php`,
    READ_PARTICIPANTE_SECOES_CONCLUIDAS_BY_PARTICIPANTE_TURMA_AND_MODULO: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoReadConcluidasByParticipanteTurmaAndModulo.php`,
    DELETE_PARTICIPANTE_SECAO_CONCLUSAO_BY_ID: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoDeleteById.php`,
    DELETE_PARTICIPANTE_SECAO_CONCLUSAO_BY_PARTICIPANTE_TURMA_AND_SECAO: `${BASE_URL}/participanteSecaoConclusao/participanteSecaoConclusaoDeleteByParticipanteTurmaAndSecao.php`,

    // Rotas para Participante Trilha Status

    UPSERT_PARTICIPANTE_TRILHA_STATUS: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusUpsert.php`,
    SET_PARTICIPANTE_TRILHA_STATUS_AND_PERCENTUAL: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusSetStatusAndPercentual.php`,
    MARK_PARTICIPANTE_TRILHA_EM_ANDAMENTO: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusMarkEmAndamento.php`,
    MARK_PARTICIPANTE_TRILHA_CONCLUIDA: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusMarkConcluida.php`,
    MARK_PARTICIPANTE_TRILHA_NAO_INICIADA: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusMarkNaoIniciada.php`,
    READ_PARTICIPANTE_TRILHA_STATUS_BY_ID: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusReadById.php`,
    READ_PARTICIPANTE_TRILHA_STATUS_BY_PARTICIPANTE_TURMA_AND_TRILHA: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusReadByParticipanteTurmaAndTrilha.php`,
    READ_PARTICIPANTE_TRILHA_STATUS_BY_PARTICIPANTE_TURMA: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusReadByParticipanteTurma.php`,
    DELETE_PARTICIPANTE_TRILHA_STATUS_BY_ID: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusDeleteById.php`,
    DELETE_PARTICIPANTE_TRILHA_STATUS_BY_PARTICIPANTE_TURMA_AND_TRILHA: `${BASE_URL}/participanteTrilhaStatus/participanteTrilhaStatusDeleteByParticipanteTurmaAndTrilha.php`,
};